import React, { useState } from "react";
import styled from "styled-components";

import useConfigs from "../hooks/useConfigs";
import useThemes from "../hooks/useThemes";
import PQR from "./PQR";
import Preguntas from "./Preguntas";

const DATA = [
  { name: "Peticiones, quejas y sugerencias", value: "peticiones" },
  { name: "Consulta de PQRs", value: "consultas" },
];

const Peticiones = () => {
  window.scroll(0, 0)
  const { fontSizeMultiplier } = useConfigs();
  const { backgroundCuarto, colorPrincipal } = useThemes();

  const [optionSelected, setOptionSelected] = useState("peticiones");

  return (
    <Container>
      <OptionContainer>
        {DATA.map((item) => (
          <Option
            key={item.value}
            fontsizemultiplier={fontSizeMultiplier}
            optionselected={optionSelected}
            value={item.value}
            background={backgroundCuarto}
            colorselected={colorPrincipal}
            onClick={() => setOptionSelected(item.value)}
          >
            {item.name}
          </Option>
        ))}
      </OptionContainer>

      {optionSelected === "peticiones" && <PQR />}
      {optionSelected === "consultas" && <Preguntas />}
    </Container>
  );
};

export default Peticiones;

// ##### Estilos #####
const Container = styled.div`
  @media (max-width: 1023px) {
    padding-top: 5vh;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Option = styled.div`
  text-align: center;
  padding: 1.5rem 2rem;
  width: 50%;
  font-size: ${(props) => 15 * props.fontsizemultiplier};
  font-weight: 700;
  cursor: pointer;
  color: ${(props) =>
    props.value === props.optionselected ? props.colorselected : "#808080"};
  background-color: ${(props) => props.background};
  border-bottom: 3px solid
    ${(props) =>
      props.value === props.optionselected
        ? props.colorselected
        : "transparent"};
`;
